import Typography from "@mui/material/Typography";
import Filter from "./Filter";
import Search from "./Search";

const LeftSideBar = () => {
	return (
		<>
			<div className="topRegions w-full pl-2 mt-3">
				<Typography className="text-lg mb-10">Filter</Typography>
				<Search />
			</div>
			<Filter />
		</>
	);
};

export default LeftSideBar;
